import { render, staticRenderFns } from "./UpdateDDATSuccess.vue?vue&type=template&id=370a107f"
import script from "./UpdateDDATSuccess.vue?vue&type=script&lang=js"
export * from "./UpdateDDATSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports